// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__rPhj0","headerAuthor":"Header_headerAuthor__rQMPf","headerTitle":"Header_headerTitle__2ka5k"};